import { z } from 'zod';
import {
  IndDesignation,
  IndGender,
  IndMaritalStatus,
  IndPrefix,
  IndResident,
  IndStatus,
  IndSuffix,
} from '@api/Entities/Ind/Ind';
import type { IndUpdateDTO } from '@api/DTO/Ind/Ind/dto';
import type { PersonalDetailsInitialValues } from './types';

import { buildDefaults, createFormModule, mapObject, valueToUndefined } from '@app/Utilities/Form';
import { Language } from '@api/Utilities/Languages';

const schema = z.object({
  indGender: z.union([z.nativeEnum(IndGender), z.literal('')]),
  indPrefix: z.union([z.nativeEnum(IndPrefix), z.literal('')]),
  indFirstname: z.string().min(1),
  indMiddlename: z.string(),
  indLastname: z.string().min(1),
  indSuffix: z.union([z.nativeEnum(IndSuffix), z.literal('')]),
  indNickname: z.string(),
  indDob: z.string(),
  indFacts: z.string(),
  indSpouse: z.number(),
  indMaritalStatus: z.union([z.nativeEnum(IndMaritalStatus), z.literal('')]),
  indDesignation: z.union([z.nativeEnum(IndDesignation), z.literal('')]),
  indOccupation: z.string(),
  indResident: z.union([z.nativeEnum(IndResident), z.literal('')]),
  prefLang: z.union([z.nativeEnum(Language), z.literal('')]),
});

const baseDefaults: PersonalDetailsValues = {
  indGender: '',
  indPrefix: '',
  indFirstname: '',
  indMiddlename: '',
  indLastname: '',
  indSuffix: '',
  indNickname: '',
  indDob: '',
  indFacts: '',
  indSpouse: undefined,
  indMaritalStatus: '',
  indDesignation: '',
  indOccupation: '',
  indResident: '',
  prefLang: undefined,
};

export const personalDetailsForm = createFormModule({
  schema,
  baseDefaults,
  defaults: (initial?: Partial<PersonalDetailsInitialValues>) =>
    buildDefaults(baseDefaults, initial),

  mapper: (values): IndUpdateDTO =>
    mapObject(values, {
      indGender: (v) => valueToUndefined(v.indGender),
      indPrefix: (v) => valueToUndefined(v.indPrefix),
      indFirstname: (v) => valueToUndefined(v.indFirstname),
      indLastname: (v) => valueToUndefined(v.indLastname),
      indSuffix: (v) => valueToUndefined(v.indSuffix),
      indNickname: (v) => valueToUndefined(v.indNickname),
      indDob: (v) => valueToUndefined(v.indDob),
      indFacts: (v) => valueToUndefined(v.indFacts),
      indSpouse: (v) => valueToUndefined(v.indSpouse),
      indMaritalStatus: (v) => valueToUndefined(v.indMaritalStatus),
      indDesignation: (v) => valueToUndefined(v.indDesignation),
      indOccupation: (v) => valueToUndefined(v.indOccupation),
      indResident: (v) => valueToUndefined(v.indResident),
      prefLang: (v) => valueToUndefined(v.prefLang),
    }),
});

export type PersonalDetailsValues = z.infer<typeof schema>;
